import Vue from 'vue'
import moment from 'moment'


Vue.filter('date-short', function (val) {
   if(val === undefined || val === null){
      return '';
   }
   return moment(val).format('DD.MM.YYYY');
});

Vue.filter('date-long', function (val) {
    if(val === undefined){
        return '';
    }
    return moment(val).format('DD.MM.YYYY HH:mm');
});


// WEBPACK FOOTER //
// ./Content/src/helpers/filters.js